import { useMemo } from 'react';
import { createImprovClient, type ImprovClient } from '../api/improvClient.js';
import { useAuth } from '../auth/AuthContext.js';

/**
 * Bind a single {@link ImprovClient} to the current auth session, mirroring {@link useAdminClient}.
 * The client reads the access token through the getter on each request (§32.3).
 */
export function useImprovClient(): ImprovClient {
  const { getAccessToken } = useAuth();
  return useMemo(() => createImprovClient(getAccessToken), [getAccessToken]);
}
